import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import "../../assets/style/TaxHeadFormByMasterHead.css";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { CustomSelect, postData } from "../Commonfunction/CommonFunction";

const TaxHeadFormByMasterHead = ({
  onClose,
  fetchData,
  taxheadSingleData,
  isAddData,
  tableData,
  rowId,
}) => {
  // console.log('rowId3333', taxheadSingleData)
  const [singleData, setSingleData] = useState(taxheadSingleData);
  const [businessTypeData, setBusinessTypeData] = useState();
  const validationSchema = Yup.object({
    business_type: Yup.string().required("Please select business type"),
    template_field: isAddData
      ? Yup.string().required("Template Field Required")
      : Yup.string(),
    additionalType: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.string().required("Please select tax type"),
          additional_tax: Yup.string().required("Additional Tax is required"),
          arithmetic: Yup.string().required("Arithmetic is required"),
        })
      )
      .required("Must have at least one tax head"),
  });
  const id = taxheadSingleData && taxheadSingleData?.id;
  // const singleData = taxheadSingleData && taxheadSingleData
  // console.log("taxheadSingleData", singleData?.types)
  // console.log("setCustomSetSingleData",taxheadSingleData)
  // const [ singleData, setSingleData ] = useState();

  const [currentMonth, setCurrentMonth] = useState("");
  useEffect(() => {
    const typeData = tableData?.map((item) => {
      return { label: item.business_type, value: item.business_type };
    });
    setBusinessTypeData(typeData);

    const now = new Date();
    // Calculate the previous month
    const previousMonthDate = new Date(now.setMonth(now.getMonth() - 1));
    // Get the previous month name
    const month = previousMonthDate.toLocaleString("default", {
      month: "long",
    });
    setCurrentMonth(month);
  }, []);

  const navigate = useNavigate();
  const lastFieldRef = useRef(null);

  const taxTypeData = [
    { label: "High", value: "High" },
    { label: "Low", value: "Low" },
    { label: "Gas", value: "Gas" },
    { label: "Diesel", value: "Diesel" },
    { label: "Non Taxable", value: "Non Taxable" },
    { label: "Other", value: "Other" },
    { label: "GA Tax", value: "GA Tax" },
    { label: "Hotel Occupancy", value: "Hotel Occupancy" },
    { label: "Room Tax", value: "Room Tax" },
    { label: "Adjustment", value: "Adjustment" },
    { label: "Custom", value: "Custom" },
    { label: "Non Food", value: "Non Food" },
    { label: "Food Sales", value: "Food Sales" },
    { label: "CBD Sales", value: "CBD Sales" },
    { label: "Non Taxable Sales", value: "Non Taxable Sales" },
    { label: "Lotto & Non Sales", value: "Lotto & Non Sales" },
    { label: "Other Misc Info", value: "Other Misc Info" },
  ];
  const taxTypeDataColor = [
    { label: "Gross Non fule", value: "#7593CE" },
    { label: "High", value: "#BAD9F8" },
    { label: "Low", value: "#F7FBFC" },
    { label: "Gas", value: "#FFE5E4" },
    { label: "Diesel", value: "#F8CACA" },
    { label: "Non Taxable", value: "#7593CE" },
    { label: "Other", value: "#BAD9F8" },
    { label: "GA Tax", value: "#F7FBFC" },
    { label: "Hotel Occupancy", value: "#FFE5E4" },
    { label: "Room Tax", value: "#F8CACA" },
    { label: "Adjustment", value: "#7593CE" },
    { label: "Custom", value: "#7593CE" },
    { label: "Non Food", value: "#BAD9F8" },
    { label: "Food Sales", value: "#F7FBFC" },
    { label: "CBD Sales", value: "#FFE5E4" },
    { label: "Non Taxable Sales", value: "#F8CACA" },
    { label: "Lotto & Non Sales", value: "#7593CE" },
    { label: "Other Misc Info", value: "#BAD9F8" },
    { label: "Calculation Total", value: "#F7FBFC" },
    { label: "Par B S U Distribution", value: "#FFE5E4" },
    { label: "S & U Return", value: "#F8CACA" },
    { label: "Vendor Compensation", value: "#7593CE" },
  ];
  const handleSubmit = async (values) => {
    try {
      const request_url = isAddData
        ? "/api/create-tax-head"
        : id
        ? `/api/update-tax-head/${id}`
        : "/api/create-tax-head";
      const postDataResult = await postData(request_url, values);
      toast.success(postDataResult?.message);
      onClose();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const transformData = (data) => {
    if (!Array.isArray(data)) return {};

    return data.reduce((acc, { type, tax_head_name }) => {
      // Convert tax_head_name to a valid key format (replace spaces and special characters with underscores)
      let formattedName = tax_head_name;

      // Initialize type array if it doesn't exist
      if (!acc[type]) {
        acc[type] = [];
      }

      // Push object with false instead of 0
      acc[type].push({ [formattedName]: false });

      return acc;
    }, {});
  };

  const headData = transformData(singleData?.types);
  const submitTransformData = (data) => {
    let result = [];

    Object.keys(data).forEach((type) => {
      data[type].forEach((item) => {
        const taxHeadName = Object.keys(item)[0]; // Extract key name
        const value = item[taxHeadName]; // Extract value

        if (value === true) {
          result.push({
            type: type,
            tax_head_name: taxHeadName.replace(/_/g, " "), // Format name properly
          });
        }
      });
    });

    return result;
  };

  return (
    <div className="form-container">
      <Formik
        enableReinitialize
        initialValues={{
          business_type: taxheadSingleData ? singleData?.business_type : "",
          template_field: "",
          additionalType: [],
          types: headData,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const output = submitTransformData(values.types);
          const updatedData = { ...values, types: output };
          handleSubmit(updatedData);
        }}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form className="tax-form tax-config-root">
            <div className="tax-form-header">
              <h2>Tax Head Configuration</h2>
            </div>

            <div className="tax-form-row">
              {rowId ? (
                <>
                  <div className="tax-form-group">
                    <label className="tax-form-label" htmlFor="business_type">
                      Business Type
                      <span className="tax-required">*</span>
                    </label>

                    {isAddData ? (
                      <>
                        <Field
                          name="business_type"
                          component={CustomSelect}
                          options={businessTypeData}
                          menuPosition="absolute"
                          className="tax-custom-select"
                          onChange={(e) => {
                            setFieldValue("business_type", e.value);
                            const selectedData = tableData?.find(
                              (item) => item?.business_type === e.value
                            );
                            setSingleData(selectedData);
                          }}
                        />
                        {errors.business_type && touched.business_type && (
                          <div className="tax-error-message">
                            {errors.business_type}
                          </div>
                        )}
                      </>
                    ) : (
                      <Field
                        disabled={true}
                        id="business_type"
                        name="business_type"
                        className="tax-form-input"
                        type="text"
                        placeholder="Business Type"
                      />
                    )}
                  </div>

                  <div className="tax-form-group">
                    {isAddData && (
                      <>
                        <label
                          className="tax-form-label"
                          htmlFor="template_field"
                        >
                          Template Field Name
                          <span className="tax-required">*</span>
                        </label>
                        <Field
                          id="template_field"
                          name="template_field"
                          className="tax-form-input"
                          type="text"
                          placeholder="Please enter Template Field"
                        />
                        {errors.template_field && touched.template_field && (
                          <div className="tax-error-message">
                            {errors.template_field}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : (
                <div className="tax-form-group tax-full-width">
                  <label className="tax-form-label" htmlFor="business_type">
                    Business Type
                    <span className="tax-required">*</span>
                  </label>
                  <Field
                    id="business_type"
                    name="business_type"
                    className="tax-form-input"
                    type="text"
                    placeholder="Please enter Business Type"
                    onChange={(e) => {
                      setFieldValue("business_type", e.target.value);
                      setFieldValue("template_field", e.target.value);
                    }}
                  />
                  {errors.business_type && touched.business_type && (
                    <div className="tax-error-message">
                      {errors.business_type}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="tax-table-container">
              <table className="tax-data-table">
                <thead>
                  <tr>
                    <th className="tax-type-column">Tax Head Type</th>
                    <th>Tax Head</th>
                    <th className="tax-checkbox-column">Select</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.keys(values?.types).map((category, categoryIndex) => (
                    <React.Fragment key={categoryIndex}>
                      {values.types[category].map((item, itemIndex) => (
                        <tr
                          key={itemIndex}
                          className={
                            itemIndex % 2 === 0 ? "tax-row-even" : "tax-row-odd"
                          }
                        >
                          {itemIndex === 0 && (
                            <td
                              rowSpan={values.types[category].length}
                              // className="tax-category-cell"
                              style={{
                                backgroundColor: (() => {
                                  const label = category.replace(/[_-]/g, " ");
                                  const match = taxTypeDataColor.find(
                                    (item) => item.label === label
                                  );
                                  return match ? match.value : "#fff";
                                })(),
                              }}
                            >
                              {category} 
                            </td>
                          )}
                          <td>{Object.keys(item)[0]}</td>
                          <td className="tax-checkbox-cell">
                            <Field
                              name={`types.${category}[${itemIndex}].${
                                Object.keys(item)[0]
                              }`}
                            >
                              {({ field }) => (
                                <label className="tax-checkbox-container">
                                  <input
                                    type="checkbox"
                                    {...field}
                                    checked={field.value || false}
                                    onChange={(e) => {
                                      setFieldValue(
                                        field.name,
                                        e.target.checked
                                      );
                                    }}
                                  />
                                  <span className="tax-checkmark"></span>
                                </label>
                              )}
                            </Field>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="tax-formula-section">
              <FieldArray name="additionalType">
                {({ push, remove }) => (
                  <div>
                    <div className="tax-section-header">
                      <h3>Local / Education Tax Formula</h3>
                      <button
                        type="button"
                        className="tax-icon-button tax-add-button"
                        onClick={() => {
                          push({
                            type: "",
                            additional_tax: "",
                            arithmetic: "",
                            id: null,
                          });
                          setTimeout(() => {
                            const targetSection = document.querySelector(
                              ".tax-formula-section"
                            );
                            targetSection?.scrollIntoView({
                              behavior: "smooth",
                              block: "end",
                            });
                          }, 100);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1z" />
                        </svg>
                      </button>
                    </div>

                    {values?.additionalType?.map((_, index) => {
                      const selectedTypes = values?.additionalType
                        ?.map((item) => item.type)
                        .filter(Boolean);

                      const output = submitTransformData(values.types);
                      const typeData = output
                        ?.map((int) => ({ label: int.type, value: int.type }))
                        ?.filter(
                          (obj, idx, self) =>
                            idx === self.findIndex((t) => t.value === obj.value)
                        );

                      const availableOptions = typeData.filter(
                        (option) =>
                          !selectedTypes?.includes(option.value) ||
                          option.value === values.additionalType[index]?.type
                      );

                      return (
                        <div key={index} className="tax-formula-row">
                          <div className="tax-form-group">
                            <label
                              className="tax-form-label"
                              htmlFor={`additionalType.${index}.additional_tax`}
                            >
                              Tax
                              <span className="tax-required">*</span>
                            </label>
                            <Field
                              name={`additionalType.${index}.additional_tax`}
                              component={CustomSelect}
                              options={[
                                {
                                  label: "Education Tax",
                                  value: "Education_Tax",
                                },
                                { label: "Local Tax 1", value: "Local_Tax_1" },
                              ]}
                              menuPosition="fixed"
                              className="tax-custom-select"
                              disabled={index !== 0}
                              onChange={(selectedOption) => {
                                const newValues = values.additionalType.map(
                                  (item, idx) => ({
                                    ...item,
                                    additional_tax:
                                      index === 0 || idx === 0
                                        ? selectedOption?.value
                                        : values.additionalType[idx]
                                            .additional_tax,
                                  })
                                );
                                setFieldValue("additionalType", newValues);
                              }}
                            />
                            {errors.additionalType &&
                              errors.additionalType[index] &&
                              errors.additionalType[index].additional_tax &&
                              touched.additionalType &&
                              touched.additionalType[index] &&
                              touched.additionalType[index].additional_tax && (
                                <div className="tax-error-message">
                                  {errors.additionalType[index].additional_tax}
                                </div>
                              )}
                          </div>

                          <div className="tax-form-group">
                            <label
                              className="tax-form-label"
                              htmlFor={`additionalType.${index}.type`}
                            >
                              Tax Type
                              <span className="tax-required">*</span>
                            </label>
                            <Field
                              name={`additionalType.${index}.type`}
                              component={CustomSelect}
                              options={availableOptions}
                              menuPosition="fixed"
                              className="tax-custom-select"
                            />
                            {errors.additionalType &&
                              errors.additionalType[index] &&
                              errors.additionalType[index].type &&
                              touched.additionalType &&
                              touched.additionalType[index] &&
                              touched.additionalType[index].type && (
                                <div className="tax-error-message">
                                  {errors.additionalType[index].type}
                                </div>
                              )}
                          </div>

                          <div className="tax-form-group">
                            <label
                              className="tax-form-label"
                              htmlFor={`additionalType.${index}.arithmetic`}
                            >
                              Computation
                              <span className="tax-required">*</span>
                            </label>
                            <Field
                              name={`additionalType.${index}.arithmetic`}
                              component={CustomSelect}
                              options={[
                                { label: "Addition", value: "+" },
                                { label: "Minus", value: "-" },
                                { label: "Multiplication", value: "*" },
                                { label: "Division", value: "/" },
                              ]}
                              menuPosition="fixed"
                              className="tax-custom-select"
                            />
                            {errors.additionalType &&
                              errors.additionalType[index] &&
                              errors.additionalType[index].arithmetic &&
                              touched.additionalType &&
                              touched.additionalType[index] &&
                              touched.additionalType[index].arithmetic && (
                                <div className="tax-error-message">
                                  {errors.additionalType[index].arithmetic}
                                </div>
                              )}
                          </div>

                          <div className="tax-button-group">
                            <button
                              type="button"
                              className="tax-icon-button tax-remove-button"
                              onClick={() => remove(index)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <path
                                  d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1z"
                                  transform="rotate(45 12 12)"
                                />
                              </svg>
                            </button>

                            {index === values.additionalType.length - 1 && (
                              <button
                                type="button"
                                className="tax-icon-button tax-add-button"
                                onClick={() => {
                                  push({
                                    type: "",
                                    additional_tax:
                                      values.additionalType[0]
                                        ?.additional_tax || "",
                                    arithmetic: "",
                                    id: null,
                                  });
                                  setTimeout(() => {
                                    const targetSection =
                                      document.querySelector(
                                        ".tax-formula-section"
                                      );
                                    targetSection?.scrollIntoView({
                                      behavior: "smooth",
                                      block: "end",
                                    });
                                  }, 100);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                >
                                  <path d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1z" />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </FieldArray>
            </div>

            <div className="tax-form-actions">
              <button
                type="button"
                className="tax-btn tax-btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
              <button type="submit" className="tax-btn tax-btn-primary">
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TaxHeadFormByMasterHead;
